var exports = {
  "iE": "x234b8571--ac8a68--wrapper",
  "wx": "x234b8571--ac8a68--header",
  "Qs": "x234b8571--ac8a68--content",
  "qr": "x234b8571--ac8a68--footer",
};

module.exports = exports;
